export default "__VITE_ASSET__CnJh4Fas__"